import React from 'react'

const Varaible_const = () => {
    return (
        <div className='container'>
            <h1>C++ Variables, Keywords and Constants</h1>
            <h3><strong>Variables in C++</strong></h3>
            <p>A variable is a value that may change during the execution of a program. C++ language has specified some rules which should be followed in order to give a variable name in a C++ program. 
                These rules are as follows :</p>
                <ul>
                    <li>A variable name must start with an alphabet.</li>
                    <li>In general, the total length of a valid variable name could be between 1 to 8, though some compiler may allow larger length i.e. length until 255 characters.</li>
                    <li>A variable name must not contain a space or a comma.</li>
                    <li>A variable name may contain an underscore.</li>
                </ul>
                <br /> <br /> <br />
                <p>Let's see an example of how we can declare variable in a program :</p>
                <br />
                <div className= 'containers'>
               <code className='library'> #include</code> &lt;iostream&gt; <br /><br />

               <code className='keywords'>using namespace std; </code><br /> <br />

               <code className='keywords'>int</code> main()<br />
&#123;<br />
<code className='keywords'>int </code> size = 1000;<br />
<code className='keywords'>float </code> ink_prc = 9.50;<br />
<code className='keywords'>short </code> dist2 = 20;<br />
<code className='keywords'>char </code> alpha_1 = 'a';<br /><br />
	
<code className='library'>cout</code>&lt;&lt;<code className='plain'> "The value in variable size is</code> : " &lt;&lt; size &lt;&lt; endl; <br />
<code className='library'>cout</code>&lt;&lt;<code className='plain'> "The value in variable inc_prc is</code> : " &lt;&lt; ink_prc  &lt;&lt; endl;<br />
<code className='library'>cout</code>&lt;&lt;<code className='plain'> "The value in variable dist2 is</code> : " &lt;&lt; dist2 &lt;&lt; endl; <br />
<code className='library'>cout</code>&lt;&lt;<code className='plain '> "The value in alpha_1 is </code>: " &lt;&lt; alpha_1 &lt;&lt; endl; <br />
	
	return 1;
&#125;
                </div>
                <div className='output'>
                    <p><strong>Output:</strong></p>
                    The value in variable size is : 1000 <br />
The value in variable inc_prc is : 9.500000 <br />
The value in variable dist2 is : 20 <br />
The value in alpha_1 is : a <br /></div>
<h1>Keywords in C++</h1>
<p><strong>Keywords</strong>  are the special words whose meaning is already defined in C++ programming language. Keywords in C++ are also known as 
reserved words because name of any keyword cannot be used for a variable name in a C++ program. There are about 64 keywords defined in C++ language
(an extension to 32 keywords in C). Let's see a table of these keywords defined in C++ language.</p>

                
                <table >
   <tbody><tr>
	<th width="%" align="center">keywords</th>
    <th align="center">keywords</th>
	<th align="center">keywords</th>
	<th align="center">keywords</th>
  </tr>
  
  
  <tr>
	<td width="25%" align="center"><b> <i>if</i></b></td>
	<td width="25%" align="center"><b> <i>else</i></b></td>
	<td width="25%" align="center"><b> <i>enum</i></b></td>
	<td width="25%" align="center"><b> <i>extern</i></b></td>
	</tr> 
	<tr>
	<td width="25%" align="center"><b> <i>float</i></b></td>
	<td width="25%" align="center"><b> <i>do</i></b></td>
	<td width="25%" align="center"><b> <i>for</i></b></td>
	<td width="25%" align="center"><b> <i>goto</i></b></td>
	</tr>
	<tr>
	<td width="25%" align="center"><b> <i>double</i></b></td>
	<td width="25%" align="center"><b> <i>int</i></b></td>
	<td width="25%" align="center"><b> <i>long</i></b></td>
	<td width="25%" align="center"><b> <i>near</i></b></td>
	</tr>
	<tr>
	<td width="25%" align="center"><b> <i>register</i></b></td>
	<td width="25%" align="center"><b> <i>return</i></b></td>
	<td width="25%" align="center"><b> <i>short</i></b></td>
	<td width="25%" align="center"><b> <i>signed</i></b></td>
	</tr>
	<tr>
	<td width="25%" align="center"><b> <i>static</i></b></td>
	<td width="25%" align="center"><b> <i>struct</i></b></td>
	<td width="25%" align="center"><b> <i>switch</i></b></td>
	<td width="25%" align="center"><b> <i>typedef</i></b></td>
	</tr>
	<tr>
	<td width="25%" align="center"><b> <i>union</i></b></td>
	<td width="25%" align="center"><b> <i>unsigned</i></b></td>
	<td width="25%" align="center"><b> <i>void</i></b></td>
	<td width="25%" align="center"><b> <i>while</i></b></td>
	</tr>
	<tr>
	<td width="25%" align="center"><b> <i>auto</i></b></td>
	<td width="25%" align="center"><b> <i>break</i></b></td>
	<td width="25%" align="center"><b> <i>char</i></b></td>
	<td width="25%" align="center"><b> <i>case</i></b></td>
	</tr>
	<tr>
	<td width="25%" align="center"><b> <i>far</i></b></td>
	<td width="25%" align="center"><b> <i>const</i></b></td>
	<td width="25%" align="center"><b> <i>continue</i></b></td>
	<td width="25%" align="center"><b> <i>default</i></b></td>
	</tr>
	
	
	
	<tr>
	<td width="25%" align="center"><b> <i>namespace</i></b></td>
	<td width="25%" align="center"><b> <i>explicit</i></b></td>
	<td width="25%" align="center"><b> <i>operator</i></b></td>
	<td width="25%" align="center"><b> <i>friend</i></b></td>
	</tr> 
	<tr>
	<td width="25%" align="center"><b> <i>public</i></b></td>
	<td width="25%" align="center"><b> <i>private</i></b></td>
	<td width="25%" align="center"><b> <i>protected</i></b></td>
	<td width="25%" align="center"><b> <i>virtual</i></b></td>
	</tr>
	<tr>
	<td width="25%" align="center"><b> <i>new</i></b></td>
	<td width="25%" align="center"><b> <i>inline</i></b></td>
	<td width="25%" align="center"><b> <i>mutable</i></b></td>
	<td width="25%" align="center"><b> <i>typename</i></b></td>
	</tr>
	<tr>
	<td width="25%" align="center"><b> <i>dynamic_cast</i></b></td>
	<td width="25%" align="center"><b> <i>reinterpret_cast</i></b></td>
	<td width="25%" align="center"><b> <i>static_cast</i></b></td>
	<td width="25%" align="center"><b> <i>const_cast</i></b></td>
	</tr>
	<tr>
	<td width="25%" align="center"><b> <i>this</i></b></td>
	<td width="25%" align="center"><b> <i>throw</i></b></td>
	<td width="25%" align="center"><b> <i>using</i></b></td>
	<td width="25%" align="center"><b> <i>class</i></b></td>
	</tr>
	<tr>
	<td width="25%" align="center"><b> <i>true</i></b></td>
	<td width="25%" align="center"><b> <i>bool</i></b></td>
	<td width="25%" align="center"><b> <i>template</i></b></td>
	<td width="25%" align="center"><b> <i>class</i></b></td>
	</tr>
	<tr>
	<td width="25%" align="center"><b> <i>catch</i></b></td>
	<td width="25%" align="center"><b> <i>try</i></b></td>
	<td width="25%" align="center"><b> <i>asm</i></b></td>
	<td width="25%" align="center"><b> <i>wchar_t</i></b></td>
	</tr>
	<tr>
	<td width="25%" align="center"><b> <i>delete</i></b></td>
	<td width="25%" align="center"><b> <i>false</i></b></td>
	</tr>

</tbody></table>
<br /> <br /> <br />
<h3>Constant</h3>
<p><strong> Constant</strong> is a value that remains the same and does not change or it cannot be 
    modified. C++ language allows us to define constants in a program, using the keyword
     const and the value of such constant does not change throughout the course of 
     execution of the program, even when one intentionally tries to modify it.
      Let's look at an example to define a constant.</p>
<div className='containers'>
<code className='comment'> // declaring a constant in C++</code > <br />
<br /> <br />
<div className='library'> <pre> {`#include<iostream>`}</pre></div>
<br /><br />
<div className='keywords'> using namespace std;</div> <br />
<br />
<code className='keywords'> int </code>main() <br />
&#123; <br />
<code className='keywords'>const int</code>	 distance = 10; <br />
	cout &lt;&lt; "<code className='plain'>The value of constant distance is </code> : " &lt;&lt; distance; <br />
  <code className='library'>return</code> 0; <br />
    &#125;
</div>
<div className='output'>
    <p><strong>Output:</strong></p>
    The value of constant distance is : 10
</div>
        </div>
    )
}

export default Varaible_const
